import { composeClassNames, ifDefined } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import calcDuration from "src/functions/calcDuration";
import { sDuration } from "src/styles/sDuration.module.scss";
import { sVideoLabel } from "src/styles/sVideoLabel.module.scss";
import { VariantSize } from "src/types/VariantSize";
import Translate from "./Translate";

type Props = {
  price: number;
  priceCurrency: string;
  size?: VariantSize | null | undefined;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
};

function MerchPrice({ price, priceCurrency, size, className, style }: Props) {
  const { locale: lang } = useRouter();
  return (
    price &&
    priceCurrency && (
      <div
        style={style}
        className={composeClassNames([
          sVideoLabel,
          "darkMerch",
          sDuration,
          size,
          className,
          "duration",
        ])}
      >
        {price} <Translate tKey={priceCurrency.toUpperCase()} />
      </div>
    )
  );
}

export default MerchPrice;
